/**
 * Trustline addresses per chain (hardcoded; not shown in UI).
 * One entry per network with enabled: true in networks.ts.
 * The factory address is set by the user via URL/ContractAddressInput.
 */
export interface EscrowChainConfig {
  trustlineValidationEngineLogic: string;
  trustlineValidationEngineProxy: string;
}

/** Hardcoded list of token addresses per chain for the deploy panel (buyer / Party A). Symbols are fetched from the contract at runtime. */
export const TOKENS_BY_CHAIN_BUYER: Record<number, string[]> = {
  10: [],
  137: [],
  998: [],
  999: [],
  8453: [],
  84532: ['0x936F8657a90D8739C0Ba83Bb420B6c4Ebd6E4438'],
  11155111: [],
  42161: [],
  43114: [],
  1440000: [],
  1449000: [],
};

/** Hardcoded list of token addresses per chain for the deploy panel (seller / Party B). Symbols are fetched from the contract at runtime. */
export const TOKENS_BY_CHAIN_SELLER: Record<number, string[]> = {
  10: [],
  137: [],
  998: [],
  999: [],
  8453: [],
  84532: ['0x17F6dc38DCcE4eE6d9265dc1a61DbBA97a08C7D1', '0xc6fC5a5b7287A44135c47bB485b48CD6e5fD8453'],
  11155111: [],
  42161: [],
  43114: [],
  1440000: [],
  1449000: [],
};

export function getTokensForChainBuyer(chainId: number): string[] {
  return TOKENS_BY_CHAIN_BUYER[chainId] ?? [];
}

export function getTokensForChainSeller(chainId: number): string[] {
  return TOKENS_BY_CHAIN_SELLER[chainId] ?? [];
}

export const ESCROW_CONFIG: Record<number, EscrowChainConfig> = {
  // Optimism
  10: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
  // Polygon
  137: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
  // Base
  8453: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
  // Base Sepolia
  84532: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
  // Hyperliquid Testnet
  998: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
  // Hyperliquid
  999: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
  // Sepolia
  11155111: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
  // Arbitrum One
  42161: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
  // Avalanche
  43114: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
  // XRPL EVM
  1440000: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
  // XRPL EVM Testnet
  1449000: {
    trustlineValidationEngineLogic: '0x3323840a5400adf89c48Dfe608Bb28fD71212da5',
    trustlineValidationEngineProxy: '0x0000000000000000000000000000000000000000',
  },
};

export function getEscrowConfig(chainId: number): EscrowChainConfig | undefined {
  return ESCROW_CONFIG[chainId];
}
